/* eslint-disable */
export const saveContactCardData = (data) => ({
  type: 'STORE_CONTACT_CARD_DATA',
  data,
});
